import { render, staticRenderFns } from "./ServersNew.vue?vue&type=template&id=32c2736d&scoped=true&"
import script from "./ServersNew.vue?vue&type=script&lang=js&"
export * from "./ServersNew.vue?vue&type=script&lang=js&"
import style0 from "./ServersNew.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ServersNew.vue?vue&type=style&index=1&id=32c2736d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c2736d",
  null
  
)

component.options.__file = "ServersNew.vue"
export default component.exports